import { InjectionKey } from "vue"

export enum EnumImportType {
  // 上传文件
  FILE,
  // 拖拽
  DRAG
}

export const UPLOAD_SUCCESS_CBS: InjectionKey<
Array<(...args: any) => any>
> = Symbol('上传成功事件回调数组')

export const UPLOAD_FILE_EVT: InjectionKey<
(v: EnumImportType) => void
> = Symbol('上传文件事件')


export enum ChunkUploadCodeEnum {
  FINISH = '00000', // 00000 表示已经上传完成
  PART_UPLOADING = '10000', // 20000 表示还未上传过
  INIT_UPLOADING = '20000', // 10000 表示部分上传
}

export interface ISimpleUploaderFile {
  aborted: boolean // 是否中断传输
  allError: boolean //
  averageSpeed: 0 // 传输速度
  completed: boolean // 是否传输完成
  currentSpeed: 0 // 当前传输速度
  error: boolean // 是否发生错误
  fileType: string // 文件类型 "video/mp4"
  id: number
  isFolder: boolean // 是否是文件夹
  isRoot: boolean //  是否是正在上传的文件
  name: string// 文件名称 "fake - 副本.mp4"
  paused: boolean // 是否暂停
  percentage: number // 传输进度
  relativePath: string // 文件相对路径 "fake - 副本.mp4"
  size: number // 文件大小（B） 115456364
  uniqueIdentifier: string // 文件唯一标识 "2e208ad7ade8d9ba4f893d39381e9976"
  ignored: boolean // 是否忽略当前文件
  progress: () => number // 获取传输进度
  resume: () => void // 获取传输进度
  [key: string]: any // 其他自定义字段
}
